import { TFooterCta } from "@shared/cms";
import Image from "next/image";
import Link from "next/link";

export function FooterCta({ title, links }: TFooterCta) {
  return (
    <section className="py-8 border-t border-gray-200">
      <div className="container flex flex-col md:flex-row justify-between md:items-center">
        <div className="text-lg mb-4 md:mb-0">{title}</div>
        {links && links.length > 0 && (
          <div className="flex gap-2">
            {links.map((link) => (
              <Link key={link.href} href={link.href} target={link.target}>
                {link.icon && (
                  <Image
                    src={link.icon?.url || ""}
                    width={link.icon?.width || 124}
                    height={link.icon?.height || 40}
                    alt={link.icon?.alternativeText || link.icon?.name || ""}
                    className="sm:h-10 w-auto object-contain"
                  />
                )}
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
